import Reflux from 'reflux';
import { Map, List, fromJS } from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import CuesheetActions from 'flux/actions/cuesheet/CuesheetActions';
import EventViewActions from 'flux/actions/EventViewActions';
import RealTimeActions from 'flux/actions/RealTimeActions';

export default Reflux.createStore({
  listenables: [CuesheetRowActions, CuesheetActions, RealTimeActions],

  mixins: [BaseMixin],

  init() {
    this.setState(Map({ visible: false }));

    this.listenTo(
      EventViewActions.populate.completed,
      'onEventPopulateCompleted',
    );
  },

  onItemRowProofHistoryClearedRealTime(showId, { rowId }) {
    if (rowId !== this._rowId) return;
    this.setInStateAndTrigger('list', new List());
  },

  onEventPopulateCompleted({ twentyFourHourClock }) {
    this.setInState('twentyFourHourClock', twentyFourHourClock);
  },

  onPopulate(teamId, eventId, showId) {
    this._teamId = teamId;
    this._eventId = eventId;
    this._showId = showId;
  },

  // eslint-disable-next-line no-unused-vars
  onPopulateCompleted({ show, itemSetList }) {
    this._itemSetListId = itemSetList._id;
    this._itemSetId = itemSetList.itemSets[0]._id;
  },

  /* eslint-disable no-unused-vars */
  onAddItemRowProofPersistentCompleted({
    itemSetId,
    rowId,
    proof,
    proofHistory,
  }) {
    /* eslint-enable no-unused-vars */
    if (rowId !== this._rowId) return;

    CuesheetRowActions.loadProofHistory(
      this._teamId,
      this._eventId,
      this._showId,
      this._itemSetId,
      rowId,
    );
  },

  onShowProofHistory(rowId, item) {
    this._rowId = rowId;

    const next = this.getState()
      .set('visible', true)
      .set('title', item.get('title'))
      .set('list', new List());

    this.setStateAndTrigger(next);

    CuesheetRowActions.loadProofHistory(
      this._teamId,
      this._eventId,
      this._showId,
      this._itemSetId,
      rowId,
    );
  },

  onClearProofHistory() {
    this.setInStateAndTrigger('list', new List());

    CuesheetRowActions.clearProofHistoryPersistent(
      this._teamId,
      this._eventId,
      this._showId,
      this._itemSetListId,
      this._itemSetId,
      this._rowId,
    );
  },

  onLoadProofHistoryCompleted(list) {
    this.setInStateAndTrigger('list', fromJS(list));
  },

  onHideProofHistory() {
    let next = this.getState().set('visible', false);

    this.setStateAndTrigger(next);
  },
});
